// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1MRUc","title":"FrontImage_title__36ZfZ"};